import { ChangeDetectorRef, Directive, effect, inject } from '@angular/core';
import { getState } from '@ngrx/signals';
import { AdvancedCommerceListingStore } from '../../store/advanced-commerce-listing.store';

@Directive()
export class AdvancedCommerceListingSizeComponentDef {
    readonly store = inject(AdvancedCommerceListingStore);
    protected changeDetectorRef = inject(ChangeDetectorRef);

    constructor() {
        // hack for detect changes in signals store
        effect(() => {
            // read store changes and update template
            const _state = getState(this.store);

            this.changeDetectorRef.detectChanges();
        });
    }
}
